
  import { Component, Vue, Prop } from 'vue-property-decorator'
  import _ from 'lodash'
  import LogoutBtn from '@/components/header/LogoutBtn.vue'
  import ToggleThemeBtn from '@/components/header/ToggleThemeBtn.vue'
  import Notifications from '@/components/header/Notifications.vue'
  import ListItemHover from '@/components/base/ListItemHover.vue'
  import Themeable from 'vuetify/lib/mixins/themeable';

  @Component({
    components: {
      ListItemHover,
      Notifications,
      ToggleThemeBtn,
      LogoutBtn,
    },
  })
  export default class DashboardCoreAppBar extends Vue {
    @Prop({ type: Boolean, default: true}) private readonly value!: boolean

    private profile: Array<{title?: string, divider?: boolean}> = [
      { title: 'Profile' },
      { title: 'Settings' },
      { divider: true },
    ]

    get pageName(): string {
      if (this.$route?.meta?.title && !this.$route.name) {
        return this.$route.meta.title
      } else if (this.$route.name) {
        return _.startCase(_.toLower(this.$route.name));
      }

      return _.startCase(_.toUpper(_.trim(this.$route.path, '/')))
    }

    get drawer(): boolean {
      return this.$store.state.drawer.visible
    }

    private setDrawer(): void {
      this.$store.commit('SET_DRAWER', !this.$store.state.drawer.visible)
    }
  }
